import { render, staticRenderFns } from "./PetDob.vue?vue&type=template&id=3d3442f9"
import script from "./PetDob.vue?vue&type=script&lang=js"
export * from "./PetDob.vue?vue&type=script&lang=js"
import style0 from "./PetDob.vue?vue&type=style&index=0&id=3d3442f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports